module.exports = __webpack_public_path__ + "img/team.5a15ce1f.jpg";